// ============================================================
// CENTRÁLNA KONFIGURÁCIA WEBU – California Košice
// Všetky kontakty, ceny a nastavenia upravuj tu.
// ============================================================

const config = {
  // --- Kontakt ---
  businessName: 'California Košice',
  phone: '+421 901 762 330',
  phoneHref: '+421910762330',
  email: 'california.kosice@gmail.com',
  whatsapp: '+421901762330', // číslo bez medzier pre wa.me odkaz
  address: 'Šemša, Košice, Slovensko',
  // Sem patrí LEN adresa z atribútu src="..." embed kódu Google Maps
  // (Zdieľať → Vloženie mapy), nie celý <iframe> kód.
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d55550.14922658427!2d21.080562476123028!3d48.67126479469231!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x473f1e696af0ab05%3A0x8c60bf4a9b0ff704!2zMDQ0IDIxIMWgZW3FoWE!5e1!3m2!1sen!2ssk!4v1784411750712!5m2!1sen!2ssk',
  social: {
    instagram: 'https://instagram.com/california.kosice',
    facebook: 'https://facebook.com/california.kosice',
  },

  // --- Vozidlo ---
  vehicleName: 'Volkswagen California Ocean T6.1',
  vehicleYear: 2020,

  // --- Kalendár obsadenosti (verejný Google Kalendár) ---
  // Primárny zdroj: Google Calendar API – spoľahlivý, funguje priamo
  // z prehliadača. Potrebuje bezplatný API kľúč:
  //   1. https://console.cloud.google.com → vytvor projekt
  //   2. „APIs & Services" → Enable „Google Calendar API"
  //   3. „Credentials" → Create credentials → API key
  //   4. Kľúč obmedz na Calendar API + HTTP referrer tvojej domény
  //   5. Vlož ho do .env v koreni projektu ako REACT_APP_GOOGLE_CALENDAR_API_KEY
  //      (po zmene .env reštartuj `npm start`)
  googleCalendarId: 'california.kosice@gmail.com',
  googleApiKey: process.env.REACT_APP_GOOGLE_CALENDAR_API_KEY || '',

  // Záložný zdroj: verejný iCal feed. Google preň neposiela CORS hlavičky,
  // preto ide požiadavka cez verejné proxy (menej spoľahlivé – slúžia len
  // ako záloha, kým nie je vyplnený googleApiKey vyššie).
  icalUrl:
    'https://calendar.google.com/calendar/ical/california.kosice%40gmail.com/public/basic.ics',
  corsProxies: [
    'https://corsproxy.io/?url=',
    'https://api.allorigins.win/raw?url=',
    'https://api.codetabs.com/v1/proxy?quest=',
  ],
  icalRefreshMinutes: 5, // ako často sa kalendár obnovuje na pozadí
  icalCacheMinutes: 5, // krátka cache v prehliadači

  // --- Rezervačné pravidlá ---
  // Prenájom sa počíta na kalendárne DNI vrátane prvého aj posledného
  // (piatok–nedeľa = 3 platené dni).
  minDays: 3,
  maxDays: 30, // konfigurovateľné maximum
  calendarMonthsAhead: 12, // koľko mesiacov dopredu zobraziť

  // --- Cenník (EUR / deň) ---
  seasons: {
    low: { label: 'Mimosezóna', months: [11, 12, 1, 2, 3, 4], price: 90 },
    mid: { label: 'Stredná sezóna', months: [5, 6, 9, 10], price: 110 },
    high: { label: 'Hlavná sezóna', months: [7, 8], price: 120 },
  },
  // V hlavnej sezóne stojí 2. a každý ďalší týždeň len 100 €/deň
  highSeasonLongStayPrice: 100,
  highSeasonLongStayFromDay: 7, // od 8. dňa (index 7)

  deposit: 1000, // vratná záloha (kaucia)

  // --- Voliteľné doplnky ---
  extras: [
    { id: 'bikeRack', label: 'Nosič bicyklov (4 bicykle)', perDay: 5, cap: 30 },
    { id: 'paddleboard', label: 'Paddleboard', perDay: 5, cap: 30 },
  ],

  // --- Plánovač trasy ---
  fuelConsumption: 8, // l / 100 km (diesel)
  dieselPrice: 1.55, // € / liter
  avgSpeed: 80, // km/h – odhad priemernej cestovnej rýchlosti

  // --- Odosielanie rezervačného e-mailu cez EmailJS (https://emailjs.com) ---
  // Vyplň po registrácii. Kým nie je vyplnené, formulár otvorí e-mailového
  // klienta zákazníka s predvyplnenou správou (mailto).
  emailJs: {
    serviceId: 'service_pb26dyn', // napr. 'service_xxxxxx'
    templateId: 'template_aezrolc', // napr. 'template_xxxxxx'
    publicKey: 'T4f2kqsKCvMJiF2G8', // napr. 'AbCdEfGh123456'
  },
};

export default config;
